<template>
  <div class="fixed left-0 top-0 h-full text-[14.5px] sm:text-base w-full" style="z-index: 99">
    <div class="fixed left-0 top-0 h-full w-full" style="z-index: 90; background-color: rgba(0, 0, 0, 0.5)"
      @click="closeModal"></div>
    <div class="bg-white w-[85%] sm:w-6/12 xl:w-4/12 absolute top-0 left-0 h-full flex flex-col p-4 md:p-8"
      style="z-index: 99">
      <div class="flex justify-between">
        <p class="font-bold uppercase text-xl sm:text-2xl">Mon panier</p>
        <img src="@/assets/img/close.png" class="w-4 h-4 cursor-pointer" @click="closeModal" />
      </div>

      <hr class="my-4" />

      <div>
        <div v-for="product in cartProducts" :key="product.id" class="flex justify-between items-center mb-2">
          <p class="font-bold w-[35%] md:w-[50%] break-words">{{ product.name }}</p>
          <div class="flex w-[65%] md:w-[50%] justify-between items-center">

            <Field :id="'quantity-' + product.id" class="selectForm !p-1 mr-1 sm:mr-2"
              :class="isDiscount ? '!w-[30%]' : '!w-[50%]'" :name="'quantity'" as="select" :value="product.quantity"
              @change="addProduct(product)">
              <option v-for="option in product.quantity_max" :key="option" :value="option">
                {{ option }}
              </option>
            </Field>

            <div class="flex text-red font-bold items-center justify-between"
              :class="isDiscount ? '!w-[70%]' : '!w-[50%]'">
              <div v-if="isDiscount" class="flex sm:gap-2 gap-1 justify-end w-full">
                <p class="text-red font-bold text-[13px] sm:text-base"
                  :class="getProductPriceDiscount(product) < getProductPrice(product) ? 'line-through text-black' : ''">
                  {{ getProductPrice(product).toFixed(2) }}€</p>
                <p v-if="getProductPriceDiscount(product) < getProductPrice(product)" class="text-red font-bold">{{
                  getProductPriceDiscount(product).toFixed(2) }}€</p>

              </div>
              <div v-else class="flex gap-2 justify-end w-full">
                <p class="text-red font-bold">{{ getProductPrice(product).toFixed(2) }}€</p>
              </div>
              <img src="@/assets/img/delete.png" class="w-4 h-4 ml-1 sm:ml-2 cursor-pointer"
                @click="removeFromCart(product)" />
            </div>
          </div>
        </div>
      </div>


      <!-- Réduction voucher (pour les gagnants wheel) -->
      <div v-if="hasVoucherDiscount && isVoucherMinimumReached">
        <hr class="my-4" />
        <div class="flex justify-between mb-2">
          <p class="font-bold border-b border-red">Bon de réduction</p>
          <div>
            <p class="font-bold">-{{ voucherDiscountAmount.toFixed(0) }}€</p>
          </div>
        </div>
      </div>

      <hr class="my-4" />

      <div class="flex justify-between">
        <p class="font-bold">Livraison à domicile sous 48H</p>
        <div v-if="shippingCost > 0">
          <p class="text-red font-bold">
            {{ shippingCost.toFixed(2) }}€
          </p>
        </div>
        <div v-else>
          <p class="text-red font-bold">0€</p>
        </div>
      </div>
      <p class="italic text-md font-bold text-red mt-3" v-if="$campaign.is_free_shipping_cost">
        Frais de livraison offerts dès {{ $campaign.brink_shipping_cost }}€ d'achat.
      </p>

      <hr class="my-4" />

      <div v-if="isDiscount" class="flex justify-between">
        <p class="font-bold">Total panier</p>
        <div>
          <p class="font-bold">{{ getTotal.toFixed(2) }}€</p>
        </div>
      </div>

      <div v-if="isDiscount" class="flex justify-between mb-2">
        <p class="font-bold border-b border-red">Réduction</p>
        <div>
          <p class="font-bold">-{{ (getTotal - getTotalWithDiscount).toFixed(2) }}€</p>
        </div>
      </div>

      <div class="flex justify-between">
        <p class="font-bold text-xl">Total</p>
        <div class="text-xl">
          <p v-if="isDiscount || hasVoucherDiscount" class="text-red font-bold">{{ getFinalTotal.toFixed(2) }}€</p>
          <p v-else class="text-red font-bold">{{ getTotal.toFixed(2) }}€</p>
        </div>
      </div>


      <button v-if="this.$store.cart.length > 0" class="button-validation flex flex-col !px-4 !mt-4"
        @click="goToResume()">
        <p class="uppercase w-full text-center">Je valide</p>
      </button>
    </div>
  </div>
</template>

<script>
import { Field } from 'vee-validate'
import router from '../../router'

export default {
  components: {
    Field
  },
  props: {},
  emits: ['removeFromCart', 'closeModal', 'addToCart'],
  computed: {
    isDiscount() {
      return !this.hasVoucherDiscount && this.$store.recall2 && this.$template.discount && this.$template.discount > 0
    },
    campaignDiscountAmount() {
      if (!this.isDiscount) return 0
      return this.getTotalWithoutShipping * (this.$template.discount / 100)
    },
    // Vérifie si on a un voucher wheel
    hasVoucherDiscount() {
      return this.$store.isWheelWinner && this.$store.winnerVoucher
    },
    // Vérifie si le minimum d'achat est atteint pour le voucher
    isVoucherMinimumReached() {
      if (!this.hasVoucherDiscount) return true
      const minimumPurchase = this.$store.winnerVoucher?.minimum_purchase || 0
      return this.getTotalWithoutShipping >= minimumPurchase
    },
    // Montant de la réduction voucher
    voucherDiscountAmount() {
      if (!this.hasVoucherDiscount || !this.isVoucherMinimumReached) return 0
      const voucherValue = this.$store.winnerVoucher?.value || 0
      // Ne pas dépasser le total du panier (hors frais de port)
      return Math.min(voucherValue, this.getTotalWithoutShipping)
    },
    subtotalAfterDiscounts() {
      return Math.max(0, this.getTotalWithoutShipping - this.campaignDiscountAmount - this.voucherDiscountAmount)
    },
    shippingCost() {
      if (this.subtotalAfterDiscounts < this.$campaign.brink_shipping_cost || !this.$campaign.is_free_shipping_cost) {
        return this.$campaign.shipping_cost
      }
      return 0
    },
    cartProducts() {
      return this.$store.cartProducts
    },
    getTotal() {
      return parseFloat((this.getTotalWithoutShipping + this.shippingCost).toFixed(2))
    },
    getTotalWithDiscount() {
      return parseFloat((this.getTotalWithoutShipping - this.campaignDiscountAmount + this.shippingCost).toFixed(2))
    },
    // Total final avec toutes les réductions (recall2 discount + voucher)
    getFinalTotal() {
      return parseFloat((this.subtotalAfterDiscounts + this.shippingCost).toFixed(2))
    },
    getTotalWithoutShipping() {
      let total = 0
      // let discount = 0

      this.cartProducts.forEach((product) => {
        total += product.reduced_price != null ? product.reduced_price * product.quantity : product.crossed_price * product.quantity
      })

      // if (this.$store.recall2 && this.$template.discount && this.$template.discount > 0) {
      //   discount = total * (this.$template.discount / 100)
      // }

      // total = total - discount.toFixed(2)

      return parseFloat(total.toFixed(2))
    }
  },
  methods: {
    getProductPriceDiscount(product) {
      let price = 0
      let discount = 0

      if (product.reduced_price != null) {
        price = product.reduced_price * product.quantity
      } else {
        price = product.crossed_price * product.quantity
      }

      if (this.$store.recall2 && this.$template.discount && this.$template.discount > 0) {
        discount = price * (this.$template.discount / 100)
      }

      price = price - discount.toFixed(2)

      return parseFloat(price.toFixed(2))
    },
    getProductPrice(product) {
      let price = 0

      if (product.reduced_price != null) {
        price = product.reduced_price * product.quantity
      } else {
        price = product.crossed_price * product.quantity
      }
      return parseFloat(price.toFixed(2))
    },
    closeModal() {
      this.$emit('closeModal')
    },
    removeFromCart(product) {
      this.$emit('removeFromCart', product.id)
    },
    goToResume() {
      router.push({ name: 'resume' })
    },

    addProduct(product) {
      let quantity = document.getElementById('quantity-' + product.id)
      this.$emit('addToCart', { id: product.id, quantity: quantity.value })
    }
  }
}
</script>

<style scoped>
.button-validation {
  background-color: v-bind("$template ? $template.products_button_background_color : ''"
    );
  color: v-bind("$template ? $template.products_button_text_color : ''");
}
</style>
